// extracted by mini-css-extract-plugin
module.exports = {"appeals_wrapper":"appeals_appeals_wrapper__36SUw","appeals_wrapper_title":"appeals_appeals_wrapper_title__1SD1-","appeals_wrapper_content":"appeals_appeals_wrapper_content__3LjyJ"};